<template>
  <div>
    <section :id="anchorsList[0].anchor || ''">
      <div class="row">
        <div class="col title">Research</div>
        <!--Mobile Only-->
        <div class="col-3 pl-1 hidden-md-up">
          <for-authors-mobile-menu :anchors-list="anchorsList"></for-authors-mobile-menu>
        </div>
        <!--Mobile Only-->
      </div>

      <div>
        <p>
          News and editorials are invited. Editorials are brief discussions of recently published papers usually in other
          leading journals by the authors of the original papers. There is the strict word limit – 800 words and no more
          than 7 references. No more than 3 co-authors, including corresponding author, are allowed.
        </p>
        <p>Note: Special title and reference format:</p>
        <p>
          Title must be short, no descriptive title, 3-7 words (for example, “RB in DNA repair”)
          Special reference format: 1 author et al, (no titles.) year. v. p.
        </p>
      </div>
    </section>
    <section :id="anchorsList[1].anchor || ''">
      <div class="row">
        <div class="col title">Editorial</div>
        <!--Mobile Only-->
        <div class="col-3 pl-1 hidden-md-up">
          <for-authors-mobile-menu :anchors-list="anchorsList"></for-authors-mobile-menu>
        </div>
        <!--Mobile Only-->
      </div>

      <div>
        <p>
          There is no page limit, no reference limit. Any number of pages and references. Up to 14 figures.
        </p>
        <p>
          Please check the submission site about the order of the sections.
        </p>
        <p>
          The list of references should be numbered consecutively according to the first time mentioned within the article.
          Cite only the number assigned to the reference: Use [ ] not ( ). References should include only the articles
          that are published or in press.
        </p>
      </div>
    </section>
    <section :id="anchorsList[2].anchor || ''">
      <div class="row">
        <div class="col title">Review</div>
        <!--Mobile Only-->
        <div class="col-3 pl-1 hidden-md-up">
          <for-authors-mobile-menu :anchors-list="anchorsList"></for-authors-mobile-menu>
        </div>
        <!--Mobile Only-->
      </div>
      <div>
        <p>
          Authors may suggest a Review on a broad topic of general interest. Should be well referenced, with a minimal
          number of references above 90. Reviews should include 1-6 figures, diagrams or cartoons.
        </p>
      </div>
    </section>
    <section :id="anchorsList[3].anchor || ''">
      <div class="row">
        <div class="col title">Book Reader</div>
        <!--Mobile Only-->
        <div class="col-3 pl-1 hidden-md-up">
          <for-authors-mobile-menu :anchors-list="anchorsList"></for-authors-mobile-menu>
        </div>
        <!--Mobile Only-->
      </div>
      <div>
        <p>
          Comprehensive coverage of the topic. Any number of figures. Color figures are especially welcome. Should be well
          referenced, with a minimal number of references above 500. There is no upper limit on the number of references.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  import ForAuthorsMobileMenu from '@/components/for-authors/ForAuthorsPageMobileMenu'
  export default {
    name: 'for-authors-style-guide-content',
    components: {ForAuthorsMobileMenu},
    props: {
      anchorsList: {
        default: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForAutorsStyleGuideContent.vue?847cdd8a